import React, { useEffect } from 'react';
import { useAuth } from './contexts/AuthContext';
import { Login } from './components/Login';
import { Dashboard } from './components/Dashboard';

function App() {
  const { user, loading } = useAuth();

  console.log('App: Render state', { user, loading, isAuthenticated: !!user });

  useEffect(() => {
    console.log('App: useEffect triggered, user state changed', { user, loading });
  }, [user, loading]);

  if (loading) {
    console.log('App: Showing loading screen');
    return (
      <div style={styles.loading}>
        <div>Loading...</div>
      </div>
    );
  }

  const showDashboard = !!user;
  console.log('App: Conditional render decision', { showDashboard, user });

  return showDashboard ? <Dashboard /> : <Login />;
}

const styles: Record<string, React.CSSProperties> = {
  loading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    fontSize: '18px',
    backgroundColor: '#f5f5f5',
  },
};

export default App;